import { useQuery } from 'react-query';

import {
  type RecentOrgChartsResponse,
  getRecentlyUpdatedOrgCharts,
} from '@utils/backend-api/orgCharts';

const RECENTLY_UPDATED_ORG_CHARTS_KEY = 'RECENTLY_UPDATED_ORG_CHARTS';

export default function useRecentlyUpdatedOrgCharts() {
  const { data, isLoading } = useQuery<RecentOrgChartsResponse>(
    RECENTLY_UPDATED_ORG_CHARTS_KEY,
    getRecentlyUpdatedOrgCharts
  );

  return { orgCharts: data?.orgCharts, isLoading };
}
